import React from 'react';

const CONTENT = {
  ro: {
    title: 'Politica de Cookie-uri',
    updated: 'Ultima actualizare: 20 februarie 2026',
    intro:
      'Această politică explică ce cookie-uri folosim pe ChessMindset.academy, de ce le folosim și cum le poți controla.',
    sections: [
      {
        title: '1. Ce sunt cookie-urile',
        body: 'Cookie-urile sunt fișiere mici stocate pe dispozitivul tău pentru a ajuta site-ul să funcționeze corect și să îmbunătățească experiența de utilizare.'
      },
      {
        title: '2. Tipuri de cookie-uri folosite',
        body: 'Folosim cookie-uri strict necesare (autentificare, sesiune, securitate), iar cookie-urile opționale pentru analiză sau marketing se activează doar după consimțământ.'
      },
      {
        title: '3. Scopul cookie-urilor necesare',
        body: 'Cookie-urile necesare permit logarea în cont, păstrarea sesiunii active, salvarea preferințelor esențiale și protecția împotriva accesului neautorizat.'
      },
      {
        title: '4. Cookie-uri opționale',
        body: 'Dacă activezi opțiunile, putem folosi cookie-uri de analiză pentru a înțelege cum este folosită platforma și pentru a îmbunătăți lecțiile, puzzle-urile și fluxurile de navigare.'
      },
      {
        title: '5. Consimțământ și preferințe',
        body: 'Poți accepta, refuza sau modifica oricând preferințele de cookie. Retragerea consimțământului nu afectează legalitatea prelucrărilor anterioare.'
      },
      {
        title: '6. Durata de stocare',
        body: 'Unele cookie-uri sunt de sesiune (se șterg la închiderea browserului), altele persistente (până la expirare sau ștergere manuală).'
      },
      {
        title: '7. Cum poți controla cookie-urile',
        body: 'Poți gestiona cookie-urile din setările browserului sau din panoul de preferințe cookie al platformei, atunci când acesta este disponibil.'
      },
      {
        title: '8. Contact',
        body: 'Pentru întrebări despre cookie-uri și date personale: contact@chessmindset.academy.'
      }
    ]
  },
  en: {
    title: 'Cookie Policy',
    updated: 'Last updated: February 20, 2026',
    intro:
      'This policy explains what cookies we use on ChessMindset.academy, why we use them, and how you can control them.',
    sections: [
      {
        title: '1. What cookies are',
        body: 'Cookies are small files stored on your device to help the website function properly and improve user experience.'
      },
      {
        title: '2. Types of cookies we use',
        body: 'We use strictly necessary cookies (authentication, session, security), while optional analytics or marketing cookies are enabled only after consent.'
      },
      {
        title: '3. Purpose of necessary cookies',
        body: 'Necessary cookies enable account login, active session persistence, essential preferences, and protection against unauthorized access.'
      },
      {
        title: '4. Optional cookies',
        body: 'If enabled by you, analytics cookies may be used to understand platform usage and improve lessons, puzzles, and navigation flows.'
      },
      {
        title: '5. Consent and preferences',
        body: 'You can accept, reject, or change cookie preferences at any time. Withdrawing consent does not affect processing carried out before withdrawal.'
      },
      {
        title: '6. Retention period',
        body: 'Some cookies are session-based (deleted when browser closes), others are persistent (kept until expiration or manual deletion).'
      },
      {
        title: '7. How to control cookies',
        body: 'You can manage cookies from browser settings or from the platform cookie preference panel, when available.'
      },
      {
        title: '8. Contact',
        body: 'For questions about cookies and personal data: contact@chessmindset.academy.'
      }
    ]
  }
};

function CookiePolicy({ language = 'ro', onBack }) {
  const c = CONTENT[language] || CONTENT.ro;

  return (
    <section className="privacy-page">
      <div className="privacy-card">
        <button type="button" className="privacy-back-btn" onClick={onBack}>
          {language === 'ro' ? '← Înapoi' : '← Back'}
        </button>
        <h1>{c.title}</h1>
        <p className="privacy-meta">{c.updated}</p>
        <p className="privacy-intro">{c.intro}</p>
        {c.sections.map((section) => (
          <article key={section.title} className="privacy-section">
            <h2>{section.title}</h2>
            <p>{section.body}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default CookiePolicy;
